import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrStaticFooter from 'client/components/SrStaticFooter';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrButton, {
  SR_BUTTON_HEIGHT_MEDIUM,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

const SrPageFooterSkipLink = ({
  buttonText,
  onNext,
  disabled,
}) => {

  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <>
      <SrBox width='100%' marginTop='18px'>
        <SrText
          display='block'
          align='center'
          color='blue300'
          font='greycliff'
          size='16'
          lineHeight='25px'
          weight='600'
          cursor='pointer'
          onClick={onNext}
        >
          Don't know? Skip this step
        </SrText>
      </SrBox>
      <SrStaticFooter>
        <SrText
          display={isSmallScreen ? 'none' : 'block'}
          lineHeight='25px'
          font='greycliff'
          color='grey600'
          fontSize='13px'
          weight='500'
        >
          Full-Service leasing with Sunroom
        </SrText>
        <SrBox width={isSmallScreen ? '100%' : 'auto'}>
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_GREEN}
            hasBoxShadow={!disabled}
            minWidth={isSmallScreen ? '100%' : '220px'}
            heightType={SR_BUTTON_HEIGHT_MEDIUM}
            onClick={onNext}
            disabled={disabled}
          >
            {buttonText}
          </SrButton>
        </SrBox>
      </SrStaticFooter>
    </>
  );
};

SrPageFooterSkipLink.propTypes = {
  buttonText: PropTypes.string,
  onNext: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

SrPageFooterSkipLink.defaultProps = {
  buttonText: 'Next',
};

SrPageFooterSkipLink.displayName = 'SrPageFooterSkipLink';

export default SrPageFooterSkipLink;
